import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import 'formdata-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ConnectedRouter } from 'connected-react-router';

import i18nClient from 'src/i18n/client';
import App from './App';
import { MSTProvider, rootStore, history } from './models';
import configureStore from './redux/configureStore';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

const store = configureStore({}, history);

const render = Component => {
  ReactDOM.render(<Component />, MOUNT_NODE);
};
//  here is everything that we dont usually hot reload
render(() => (
  <I18nextProvider i18n={i18nClient()}>
    <MSTProvider value={rootStore}>
      <ReduxProvider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </ReduxProvider>
    </MSTProvider>
  </I18nextProvider>
));

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (process.env.NODE_ENV === 'production') {
  require('offline-plugin/runtime').install(); // eslint-disable-line global-require
}
